(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/engines/topp5.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/engines/topp5.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const gameTypes = svs.racing.common.constants.gameTypes;
const createEngineUnitCombined = svs.racing.gameEngine.engines.createEngineUnitCombined;
const createEngineTopRank = svs.racing.gameEngine.engines.createEngineTopRank;
const createEngineTopRankPix = svs.racing.gameEngine.engines.createEngineTopRankPix;
const optionsExtend = [{
  amount: 60,
  systemSize: 3
}, {
  amount: 80,
  systemSize: 4,
  more: true
}, {
  amount: 100,
  systemSize: 5
}, {
  amount: 200,
  systemSize: 10
}, {
  amount: 720,
  systemSize: 36
}, {
  amount: 3000,
  systemSize: 150,
  more: true
}];
const options = {
  gameType: gameTypes.TOPP5,
  subProductId: 'RX5IO',
  xpert: {
    data: [{
      amount: 20,
      systemSize: 1,
      more: true
    }, {
      amount: 120,
      systemSize: 6,
      more: true
    }, {
      amount: 240,
      systemSize: 12,
      more: true
    }, {
      amount: 360,
      systemSize: 18
    }, {
      amount: 480,
      systemSize: 24
    }, {
      amount: 960,
      systemSize: 48,
      more: true
    }]
  },
  hasReserve: true,
  numPositions: 5,
  stake: {
    amounts: [5, 10, 20],
    amountsDefaultIndex: 2,
    freeAmountAvailable: false,
    min: 20,
    max: 60000,
    rowPrice: 1
  }
};

options.xpert.data = [...options.xpert.data, ...optionsExtend].sort((a, b) => {
  if (a.systemSize < b.systemSize) {
    return -1;
  }
  if (a.systemSize > b.systemSize) {
    return 1;
  }
  return 0;
});
const topp5 = createEngineTopRank(_objectSpread(_objectSpread({}, options), {}, {
  anyOrderAvailable: false
}));
const topp5System = createEngineUnitCombined(_objectSpread(_objectSpread({}, options), {}, {
  unordered: false,
  anyOrderAvailable: true
}));
const topp5PixCustom = createEngineTopRankPix(_objectSpread(_objectSpread({}, options), {}, {
  anyOrderAvailable: false
}));
svs.racing.gameEngine.engines.topp5 = topp5;
svs.racing.gameEngine.engines.topp5System = topp5System;
svs.racing.gameEngine.engines.topp5PixCustom = topp5PixCustom;

 })(window);